import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { capitalize } from '@/modules/core/app/helpers/StringHelper';

export class WorkflowTriggerType extends Enum {
  key!: string;
  value!: string;

  static ESTATE_CREATED: WorkflowTriggerType = {
    key: 'estate_created',
    get value() {
      return capitalize(Lang.t('workflow.estate-created'));
    }
  };

  static ESTATE_STATUS_CHANGED: WorkflowTriggerType = {
    key: 'estate_status_changed',
    get value() {
      return capitalize(Lang.t('workflow.estate-status-changes'));
    }
  };

  static GUIDANCE_STEP_COMPLETED: WorkflowTriggerType = {
    key: 'guidance_step_completed',
    get value() {
      return capitalize(Lang.t('workflow.step-is-completed'));
    }
  };

  static NOTARY_STATUS_CHANGED: WorkflowTriggerType = {
    key: 'notary_status_changed',
    get value() {
      return capitalize(Lang.t('workflow.notary-status-changes'));
    }
  };

  static NEEDS_ESTATE_PROFESSIONAL: WorkflowTriggerType = {
    key: 'needs_estate_professional',
    get value() {
      return capitalize(Lang.t('workflow.needs-estate-professional'));
    }
  };

  static PRIMARY_ESTATE_PROFESSIONAL_ASSIGNED: WorkflowTriggerType = {
    key: 'primary_estate_professional_assigned',
    get value() {
      return capitalize(Lang.t('workflow.primary-ep-is-assinged'));
    }
  };

  static ESTATE_HEALTH_CHECK_RECOMMENDATION_STATUS_CHANGED: WorkflowTriggerType = {
    key: 'estate_health_check_recommendation_status_changed',
    get value() {
      return capitalize(Lang.t('workflow.estate-health-check-recommendation-status-changes'));
    }
  };
}
